module.exports = __webpack_public_path__ + "img/bindcard_content_bg.22c3f6d1.png";